import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CurrentMachineComponent } from "./current-machine.component";
import { MachineActivityComponent } from "./machine-activity/machine-activity.component";
import { MachineMediumComponent } from "./machine-medium/machine-medium.component";
import { MachinePartInfoDetailComponent } from "./machine-part-info/machine-part-info-detail/machine-part-info-detail.component";
import { MachinePartInfoComponent } from "./machine-part-info/machine-part-info.component";
import { DxButtonModule, DxDataGridModule, DxDropDownButtonModule, DxLoadIndicatorModule, DxSelectBoxModule, DxSwitchModule, DxTabPanelModule, DxTextBoxModule } from "devextreme-angular";
import { DxiItemModule } from "devextreme-angular/ui/nested";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgxSpinnerModule } from "ngx-spinner";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin, PipesModule } from "acl-cloud-lib";
import { ReactiveFormsModule } from "@angular/forms";
import { MachineInfoConfigComponent } from "./machine-info-config/machine-info-config.component";
import { VisibleForRolesDirective } from "../../core/auth/visible-for-roles.directive";
import { MachineStructureTreeListComponent } from "../../shared/components/machine-structure-tree-list/machine-structure-tree-list.component";

const routes: Routes = [
  {
    path: '',
    component: CurrentMachineComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { breadcrumb: 'Machine' }
  }
];

@NgModule({
  declarations: [
    MachineActivityComponent,
    MachineMediumComponent,
    MachinePartInfoComponent,
    MachinePartInfoDetailComponent,
    CurrentMachineComponent,
    MachineInfoConfigComponent
  ],
  imports: [
    FontAwesomeModule,
    CommonModule,
    DxLoadIndicatorModule,
    VisibleForRolesDirective,
    DxTabPanelModule,
    DxiItemModule,
    DxDataGridModule,
    DxButtonModule,
    DxSwitchModule,
    DxSelectBoxModule,
    DxDropDownButtonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    RouterModule.forChild(routes),
    PipesModule,
    DxTextBoxModule,
    MachineStructureTreeListComponent
  ]
})
export class CurrentMachineModule { }